import React, {ReactNode, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {DefaultTFuncReturn} from "i18next";
import {closeModal, ConfirmProps} from "app/reducers/modalSlice";
import {useAppDispatch} from "app/store/hook";
import ArcButton, {ButtonType} from "app/components/arc/ArcButton";

export default function AppAlert(props: Readonly<ConfirmProps>) {
  const {
    type= 'alert',
    title,
    message,
    onConfirm,
    onClose,
  } = props;

  const {t} = useTranslation();
  const dispatch = useAppDispatch();

  const [alertTitle, setAlertTitle] =
    useState<string|DefaultTFuncReturn|undefined>(undefined);
  const [alertMsg, setAlertMsg] = useState<ReactNode>(undefined);

  useEffect(() => {
    if('delete' === type) {
      setAlertTitle(title?title:t('confirm.label.message.delete'));
      setAlertMsg(message??t('confirm.label.message.deleteConfirm'))
    } else if ('save' === type) {
      setAlertTitle(title ?? t('confirm.label.message.save'));
      setAlertMsg(message ?? t('confirm.label.message.saveConfirm'))
    } else if ('status' === type) {
      setAlertTitle(title ?? t('confirm.label.message.statusChange'));
      setAlertMsg(message ?? t('confirm.label.message.statusChangeConfirm'))
    } else {
      setAlertTitle(title??'');
      setAlertMsg(message??'');
    }
  }, []);

  const handleClickConfirm = () => {
    dispatch(closeModal());
    if(onConfirm) {
      onConfirm();
    }
  }

  const handleClickClose = () => {
    dispatch(closeModal());
    if(onClose) {
      onClose();
    }
  }

  return (
    <>
      <h3 className="titT1">{alertTitle}</h3>
      <div className="layer-cont" style={{overflowY: "visible"}}>
        {alertMsg}
      </div>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem', marginTop: '2rem'}}>
        {props.type !== 'alert' && (<ArcButton type={ButtonType.cancel} onClick={handleClickClose} />)}
        <ArcButton type={ButtonType.confirm} onClick={handleClickConfirm} />
      </div>
    </>
  )

}